"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _GoogleSignInButton = _interopRequireDefault(require("web/realea/components/GoogleSignInButton"));
var _styles = require("web/realea/pages/Login/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* Login page (/login). It centers the Google sign-in button; when already
* signed in it just confirms that and links home. Session state comes from
* the Layout via the router outlet context.
*/
function LoginPage() {
  const _useOutletContext = (0, _reactRouterDom.useOutletContext)(),
    session = _useOutletContext.session;
  if (session.status === "loading") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)({}, stylex.props(_styles.styles.wrapper)));
  }
  if (session.isLoggedIn) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.wrapper)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.title)), {}, {
        children: "You're signed in."
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
        to: "/"
      }, stylex.props(_styles.styles.homeLink)), {}, {
        children: "Go to Realea"
      }))]
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.wrapper)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.title)), {}, {
      children: "Sign in to Realea"
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GoogleSignInButton.default, {
      onSignedIn: session.refresh
    })]
  }));
}
var _default = exports.default = LoginPage;